<div
  class="create-digital-account__dialog-box"
  [mmTestId]="'CUSTOMERS_LIST_PAGE.CREATE_DIGITAL_IDENTITY_MODAL_CONTENT'"
>
  <mm-dialog-title>
    <div class="create-digital-account__dialog-header">
      <mm-icon [name]="'info'" class="create-digital-account__info-icon"></mm-icon>
      <p class="create-digital-account__dialog-title">
        {{ 'PAGES.AUTH.EMPLOYEE.CREATE_DIGITAL_ACCOUNT.DAILOG.TITLE.TEXT' | translate }}
      </p>
    </div>
  </mm-dialog-title>

  <hr class="create-digital-account__dialog-divider" />

  <mm-dialog-content class="create-digital-account__dialog-content">
    {{ 'PAGES.AUTH.EMPLOYEE.CREATE_DIGITAL_ACCOUNT.DAILOG.DESCRIPTION.TEXT' | translate }}
  </mm-dialog-content>

  <app-advanced-form
    [config]="advancedFormConfig"
    (events)="onAdvancedFormEvents($event)"
    [mmTestId]="'CUSTOMERS_LIST_PAGE.CREATE_DIGITAL_IDENTITY_MODAL_FORM'"
  ></app-advanced-form>

  <mm-dialog-footer>
    <div class="create-digital-account__dialog-footer">
      <p>
        {{ 'PAGES.AUTH.EMPLOYEE.CREATE_DIGITAL_ACCOUNT.DAILOG.FOOTER_NOTICE.TEXT' | translate }}
      </p>
    </div>
  </mm-dialog-footer>
</div>
